import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getAchievement = (title, img, description) => ({
  title,
  img,
  description,
})

const ACHIEVEMENTS = {
  consultant: getAchievement('Консультант по безопасности личного профиля', require('./assets/consultant.svg'), 'Проводит проверку активностей и данных клиента в сети на предмет уязвимостей, и помогает обеспечить конфиденциальность и общую безопасность. В том числе помогает настроить приватность профиля в социальных сетях, отредактировать или удалить лишнюю информацию.'),
  researcher: getAchievement('Исследователь мобильных угроз', require('./assets/researcher.svg'), 'Анализирует работу мобильных приложений и операционных систем в смартфонах и планшетах. Помогает распознать вредоносные программы, которые могут маскироваться под мобильные игры и другие приложения.'),
  web: getAchievement('Веб-контент аналитик', require('./assets/web.svg'), 'Изучает сайты и сервисы с точки зрения возможности кражи персональной и платежной информации пользователя. Анализирует и раскрывает мошеннические схемы (скам, фишинг, спам). Помогает улучшить информационную безопасность для банков, интернет-магазинов  и многих других компаний.'),
  expert: getAchievement('Эксперт по кибербезопасности', require('./assets/expert.svg'), 'Разрабатывает правила информационной безопасности для частных лиц и компаний. Анализирует  возможные киберугрозы и помогает с ними бороться, участвует в совершенствовании защитных решений.'),
}

export default new Vuex.Store({
  state: {
    result: 0,
    maxResult: 70, // 1 - 65, 2 - 70, 3 - 70
    progress: 0,
    achievements: Array(3),
    hexColor: 'green',
    hexRotation: 90.0,
  },
  mutations: {
    SET_RESULT(state, result) {
      state.result += result
      state.progress = state.result / state.maxResult * 100
    },
    SET_PROGRESS() {
      // state.progress += progress
      // if (state.progress > 100) state.progress = 100
    },
    SET_HEX_COLOR(state, hexColor) {
      state.hexColor = hexColor
    },
    SET_HEX_ROTATION(state) {
      state.hexRotation += 90
    },
    SET_ACHIEVEMENT(state, achievement) {
      const index = state.achievements.findIndex(i => Boolean(i) === false)

      if (index === -1) return

      state.achievements[index] = achievement
      state.achievements = state.achievements.slice()
    },
    SET_ACHIEVEMENTS_COUNT(state, count) {
      state.achievements = Array(count)
    },
    SET_MAX_RESULT(state, max) {
      state.maxResult = max
    },
  },
  actions: {
    setAchievement({ state, commit }, id) {
      const achievement = ACHIEVEMENTS[id]

      if (state.achievements.find(i => i === achievement)) return null

      commit('SET_ACHIEVEMENT', achievement)

      return achievement
    },
  },
  modules: {
  },
})
